import React from "react";

import Heading from "@common/components/Heading/Heading";
import PageTitle from "@common/components/PageTitle/PageTitle";
import PageWrap from "@common/components/PageWrap/PageWrap";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { Spinner } from "@common/components/Spinner/Spinner";
import identifiers from "@common/util/identifiers.json";
import { t } from "@common/util/translator";

import { ApprovedDomainsCard } from "../../components/ApprovedDomainsCard/ApprovedDomainsCard";
import TeamMembersCard from "../../components/TeamMembersCard/TeamMembersCard";
import { useApprovedDomainsConsumer } from "../../consumers/useApprovedDomainsConsumer";
import { useTeamMembersConsumer } from "../../consumers/useTeamMembersConsumer";

export default function MembersView() {
  const {
    domains,
    addApprovedDomain,
    deleteApprovedDomain,
    initialLoading: domainInitialLoad,
    loading: domainsLoading,
  } = useApprovedDomainsConsumer();
  const {
    teamData,
    inviteMembers,
    deleteMember,
    deleteMemberInvitation,
    customizeTeamMember,
    resendInvite,
    deleteCurrentMember,
    initialLoading: membersInitialLoad,
    loading: membersLoading,
  } = useTeamMembersConsumer();

  return (
    <>
      <Title />
      {domainInitialLoad || membersInitialLoad ? (
        <Spinner />
      ) : (
        <PageWrap>
          <ApprovedDomainsCard
            domains={domains}
            addApprovedDomain={addApprovedDomain}
            deleteApprovedDomain={deleteApprovedDomain}
            loading={domainsLoading}
          />
          <TeamMembersCard
            teamData={teamData}
            inviteMembers={inviteMembers}
            deleteMember={deleteMember}
            deleteMemberInvitation={deleteMemberInvitation}
            customizeTeamMember={customizeTeamMember}
            resendInvite={resendInvite}
            deleteCurrentMember={deleteCurrentMember}
            loading={membersLoading}
          />
        </PageWrap>
      )}
    </>
  );
}

const Title = () => (
  <PageTitle>
    <Heading
      as="h1"
      heading1
      marginBottom={8}
      testId={identifiers["workspaceAdministration.header.members"]}
    >
      {t("administration.members.heading")}
    </Heading>
    <Paragraph>{t("administration.members.subtitle")}</Paragraph>
  </PageTitle>
);
